import React, { useState, useEffect } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import Input from "../../../components/ui/Input";

const NotificationFormModal = ({
  isOpen,
  onClose,
  onSave,
  item,
  mode,
  language,
}) => {
  const [formData, setFormData] = useState({
    title: "",
    body: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (item) {
      setFormData({
        title: item?.title || "",
        body: item?.body || "",
      });
    } else {
      setFormData({
        title: "",
        body: "",
      });
    }
    setErrors({});
  }, [item, isOpen]);

  const labels = {
    addTitle: { en: "Add New Notification", ar: "إضافة إشعار جديد" },
    editTitle: { en: "Edit Notification", ar: "تعديل الإشعار" },
    title: { en: "Title", ar: "العنوان" },
    body: { en: "Message", ar: "الرسالة" },
    cancel: { en: "Cancel", ar: "إلغاء" },
    save: { en: "Save", ar: "حفظ" },
    required: { en: "This field is required", ar: "هذا الحقل مطلوب" },
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData?.title?.trim()) {
      newErrors.title = labels?.required?.[language];
    }

    if (!formData?.body?.trim()) {
      newErrors.body = labels?.required?.[language];
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      onSave({
        title: formData.title.trim(),
        body: formData.body.trim(),
      });
    }
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));

    if (errors?.[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-card rounded-xl shadow-elevation-4 border border-border w-full max-w-md max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-card border-b border-border px-6 py-4 flex items-center justify-between">
          <h2 className="text-xl font-semibold text-foreground">
            {mode === "add"
              ? labels?.addTitle?.[language]
              : labels?.editTitle?.[language]}
          </h2>

          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-muted transition-smooth"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <Input
            label={labels?.title?.[language]}
            value={formData?.title}
            onChange={(e) => handleChange("title", e?.target?.value)}
            error={errors?.title}
            required
          />

          <div>
            <label className="block text-sm font-medium mb-2">
              {labels?.body?.[language]}
            </label>
            <textarea
              value={formData?.body}
              onChange={(e) => handleChange("body", e?.target?.value)}
              className="w-full px-3 py-2 rounded-lg border border-border bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-ring min-h-[100px]"
            />
            {errors?.body && (
              <p className="text-sm text-error mt-1">{errors.body}</p>
            )}
          </div>

          <div className="flex gap-3 pt-4">
            <Button
              type="button"
              variant="outline"
              fullWidth
              onClick={onClose}
            >
              {labels?.cancel?.[language]}
            </Button>

            <Button type="submit" variant="default" fullWidth>
              {labels?.save?.[language]}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NotificationFormModal;